import Vue from 'vue'
import Vuex from 'vuex'
import login from './login'
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)

const VuexPersist = new VuexPersistence({
  storage: window.sessionStorage,
  reducer: (state) => ({
    login: {
      // newRouter: [],
      token: state.login.token,
      locale: state.login.locale,
      langImg: state.login.langImg
      // account: state.login.account,
      // merchantId: state.login.merchantId,
      // lastLoginIp: state.login.lastLoginIp,
      // lastLoginTime: state.login.lastLoginTime,
      // role: state.login.role,
      // roleBackend: state.login.roleBackend,
      // permissionFrontNameList: state.login.permissionFrontNameList
    }
  })
})

// 創建 store 實例
const store = new Vuex.Store({
  modules: {
    login
  },
  plugins: [VuexPersist.plugin]
})

export default store
